import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    documentos: []
  },
  actions: {
    addDocumentos (context, formData) {
      return new Promise((resolve, reject) => {
        axios.post('/api/documentos', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    getDocumentos ({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/documentos')
          .then((response) => {
            commit('setDocumentosMutation', response.data['hydra:member'])
            resolve(response.data['hydra:member'])
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    downloadDocumento (context, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/documentos/${id}`, {responseType: 'blob'})
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteDocumento (context, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/documentos/${id}`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    }
  },
  mutations: {
    setDocumentosMutation (state, docs) {
      const filtrado = docs.filter(doc => doc.valTipoDocumento === '/api/val_tipo_documentos/7')
      console.log({filtrado})
      state.documentos = filtrado
    }
  },
  modules: {}
})